import { fundingHqFetch } from './fundingApi';

export async function fetchFundingDashboardSummary(agencyId) {
  return fundingHqFetch(`/dashboard?agency_id=${encodeURIComponent(agencyId)}`);
}
